export function tokenDecode(token: string) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

export function getBackUrl() {
  return process.env.REACT_APP_BACKEND_URL;
}

export function getPortalOrigin() {
  return (process.env.REACT_APP_PORTAL_ORIGIN || '').replace(/\/$/, '');
}

/** Relative portal paths like `/download_file.html?file_id=…` → absolute URL on corp portal. */
export function resolvePortalUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;

  const origin = getPortalOrigin();
  if (!origin) return path;

  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
}
